<template>
  <div id="simple-navigation" class="simple-navigation">
    <b-navbar
      transparent
      :class="{ 'is-home': isAtHome, 'is-contrast': isContrast }"
    >
      <template slot="start">
        <b-navbar-item
          v-for="(link, index) of linksFiltered"
          :id="link.testId"
          :key="index"
          v-scroll-to="link.id"
          class="nav-button is-uppercase"
          :class="{ 'at-home': isAtHome }"
          tag="routerLink"
          :to="link.to"
          :rel="link.rel"
        >
          {{ link.text }}
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { Home, App } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "SimpleNavigation",
  computed: {
    ...mapGetters(["isContrast"]),
    isAtHome() {
      return this.$router.currentRoute.path === "/";
    },
    links() {
      return [
        {
          text: Home.HOME,
          to: "/",
          rel: "",
          id: "#login",
          testId: "home-login-button"
        },
        {
          text: Home.COMMON_QUESTIONS,
          to: this.isAtHome ? "" : "/#FAQ",
          rel: "help",
          id: "#FAQ",
          testId: "FAQ-button"
        },
        {
          text: App.Channel.TITLE,
          to: this.isAtHome ? "" : "/#attendance",
          rel: "help",
          id: "#attendance",
          testId: "information-button"
        },
        {
          text: Home.VALIDATION,
          to: "/validar-documento",
          rel: "",
          id: "#validator",
          testId: "validation-button"
        },
        {
          text: Home.LEGISLATIONS,
          to: "/leis-referencias",
          rel: "",
          testId: "legislation-button"
        }
      ];
    },
    linksFiltered() {
      return this.isAtHome
        ? this.links.filter(link => link.id != "#login")
        : this.links;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.simple-navigation {
  z-index: 30;
  display: flex;
}

.simple-navigation.buttons.is-right > button {
  background-color: transparent !important;
  border: none;
  color: white;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
  font-weight: 600;

  &:hover,
  &:focus {
    background-color: rgba(0, 175, 143, 0.8) !important;
    border: none;
  }

  &:active {
    background-color: rgba(0, 175, 143, 1) !important;
    border: none;
  }
}

nav.navbar {
  .navbar-item {
    padding: 0px;
    background-color: transparent !important;
  }

  .nav-button {
    padding: calc(0.5em - 1px) 1em;
    border: none;
    font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    font-weight: 600;
    height: 100%;
    &:focus {
      box-shadow: none;
    }

    @media screen and (min-width: 1024px) {
      color: $color-21 !important;
      background-color: transparent !important;

      &:hover,
      &:active {
        text-shadow: 1px 2px 1px $color-26;
      }

      &.at-home {
        color: white !important;

        &:hover,
        &:active {
          text-shadow: 1px 2px 1px black;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/variables";
.navbar {
  &.is-home .navbar-burger {
    @media screen and (max-width: $tablet-low) {
      color: $color-7;
    }
  }
  &.is-contrast:not(.is-home) .navbar-burger {
    color: $color-1;
  }
}
</style>
